module.exports = __webpack_public_path__ + "static/SamAdams-Page_07-76a538e1925c4dc60be3c5eaaf589a9f.jpg";